class ApiError extends Error {
  _status: number

  constructor(statusCode: number, message?: string) {
    super(message)
    this._status = statusCode
  }

  get status() {
    return this._status
  }
}

export default ApiError
